import { render, staticRenderFns } from "./StudentPasswordResetTimeout.vue?vue&type=template&id=74dc0f7d&scoped=true&lang=pug&"
import script from "./StudentPasswordResetTimeout.vue?vue&type=script&lang=ts&"
export * from "./StudentPasswordResetTimeout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc0f7d",
  null
  
)

export default component.exports